import React, { useState } from "react";
import { Button, Tag } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  RightOutlined,
  SafetyOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { RetainedSlotsNote } from "../compoinents/RetainedSlotsNote";
import lib from "../../assets/utils/lib";
import { PolicyHolderModal } from "../compoinents/userData";
import { ADMIN_REVIEW_MODAL_CLASS } from "../dashboard/utils";

const formatDate = (value) => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? String(value) : d.toLocaleDateString();
};

function CategoryTag({ category }) {
  const isCorporate = String(category || "").toLowerCase() === "corporate";
  return (
    <Tag color={isCorporate ? "blue" : "green"} className="listing-card__tag">
      {(category || "individual").toUpperCase()}
    </Tag>
  );
}

function Fact({ children }) {
  if (children == null || children === "") return null;
  return <span className="listing-card__fact">{children}</span>;
}

/**
 * Compact linear client / policy card for verification queue and search.
 */
export function ClientListingCard({ record, actions, onClick }) {
  const active = record?.status != null ? lib.unifiedSearchIsActiveStatus(record.status) : null;
  const isCorporate = String(record?.category || "").toLowerCase() === "corporate";
  const enrolleeCount =
    record?.active_enrollees != null
      ? `${record.active_enrollees}/${record?.enrolee_size ?? 0} enrollees`
      : record?.enrolee_size != null
        ? `${record.enrolee_size} slots`
        : null;

  return (
    <article
      className="listing-card listing-card--linear search-result-card"
      onClick={onClick}
      onKeyDown={onClick ? (e) => e.key === "Enter" && onClick() : undefined}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="listing-card__lead">
        <div className={`listing-card__icon ${isCorporate ? "is-corporate" : "is-individual"}`}>
          {isCorporate ? <SafetyOutlined /> : <UserOutlined />}
        </div>
        <div className="listing-card__identity">
          <h3 className="listing-card__title">{record?.name || "—"}</h3>
          <p className="listing-card__meta">{record?.policy_no || "No policy number"}</p>
        </div>
      </div>

      <div className="listing-card__facts">
        <Fact>{record?.email}</Fact>
        <Fact>{record?.phone}</Fact>
        <Fact>{record?.insurance_package?.toUpperCase?.()}</Fact>
        <Fact>{record?.premium_type?.toUpperCase?.()}</Fact>
        <Fact>{enrolleeCount}</Fact>
        <RetainedSlotsNote source={record} />
        <Fact>{formatDate(record?.date) ? `Joined ${formatDate(record.date)}` : null}</Fact>
      </div>

      <div className="listing-card__aside" onClick={(e) => e.stopPropagation()}>
        <CategoryTag category={record?.category} />
        {active != null ? (
          <span className={`listing-card__status ${active ? "is-active" : "is-inactive"}`}>
            {active ? <CheckOutlined /> : <CloseOutlined />}
            {active ? "Active" : "Inactive"}
          </span>
        ) : null}
        {actions}
        {onClick ? <RightOutlined className="listing-card__chevron" aria-hidden /> : null}
      </div>
    </article>
  );
}

export function VerifyClientCard({ data }) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <ClientListingCard
        record={data}
        onClick={() => setShowModal(true)}
        actions={
          <Button type="link" size="small" className="listing-card__action" onClick={() => setShowModal(true)}>
            Review
          </Button>
        }
      />
      {showModal ? (
        <PolicyHolderModal
          data={data}
          display={showModal}
          action={() => setShowModal(false)}
          onclose={() => setShowModal(false)}
          showAllActions
          modalClassName={ADMIN_REVIEW_MODAL_CLASS}
        />
      ) : null}
    </>
  );
}
